export const TINY_MCE_KEY =
  process.env.VUE_APP_TINY_MCE_KEY ||
  '8vjlw1dp9mrq6rf2vyhj1b29sxf984sampnafyvn7w85aulz'

export default {
  URL: process.env.VUE_APP_API_URL,
  LANG: process.env.VUE_APP_LANG,
  TINY_MCE_KEY,
  FRONT_END_URL: process.env.VUE_APP_FRONT_END_URL,
  GLOBAL_ADMIN_URL: process.env.VUE_APP_GLOBAL_ADMIN_URL
}

export const TENANCY_SETTINGS = {
  TENANCY: process.env.VUE_APP_TENANCY === 'true',
  TENANCY_COUNTRY: process.env.VUE_APP_TENANCY_COUNTRY,
  TENANCY_LOCAL: process.env.VUE_APP_TENANCY_LOCAL === 'true'
}
